import React, { Component } from 'react';
import PropTypes from '../../../types';
import { GenericDescriptionList } from 'web-ui-components/lib/data/lists';
import { SectionHeading } from 'web-ui-components/lib/typography/headings';
import { NavigationButton } from 'web-ui-components/lib/navigation/buttons';
import { getTitle } from '../../significantPeopleSection/officerComponent';
import { Content } from '../../../infrastructure/content';
import OldAddSignatoryPage from '../../oldAddSignatorySection/OldAddSignatoryPage';
import {
  getNationality,
  getCountryOfResidence
} from '../../../infrastructure/oldSignatories/utils/mapSignatoryDetails';
import { CountryUtil } from '../../../components/utils/countryUtils';

class OldSignatoriesAccordian extends Component {
  constructor(props) {
    super(props);
    this.state = { isFormEditable: false };
    this.onEditButtonClick = this.onEditButtonClick.bind(this);
  }

  onEditButtonClick() {
    this.setState({ isFormEditable: !this.state.isFormEditable });
  }

  getItems(
    personDetailsFirstName,
    personDetailsMiddleName,
    personDetailsLastName,
    personDetailsDOB,
    nationalityTitle,
    countryOfResidence,
    signatory
  ) {
    const list = [{ key: personDetailsFirstName, value: signatory.firstName }];

    if (signatory.middleName) {
      list.push({
        key: personDetailsMiddleName,
        value: signatory.middleName
      });
    }

    list.push({ key: personDetailsLastName, value: signatory.lastName });
    list.push({
      key: personDetailsDOB,
      value: `${signatory.dob.dateField}/${signatory.dob.monthField}/${signatory.dob.yearField}`
    });
    list.push({
      key: nationalityTitle,
      value: CountryUtil.getNationalityForCountryCode(getNationality(signatory))
    });
    list.push({
      key: countryOfResidence,
      value: CountryUtil.getValueForCountryCode(getCountryOfResidence(signatory))
    });
    return list;
  }

  render() {
    const {
      signatory,
      signatoriesIndex,
      brandId,
      bankId,
      removeOldSignatories,
      updateOldSignatories
    } = this.props;

    const reviewTitle = signatory.middleName
      ? `${signatory.firstName} ${signatory.middleName} ${signatory.lastName}`
      : `${signatory.firstName} ${signatory.lastName}`;

    return (
      <Content>
        {({
          personDetailsFirstName,
          personDetailsLastName,
          personDetailsDOB,
          nationalityTitle,
          countryOfResidence,
          personDetailsMiddleName
        }) => (
          <>
            <SectionHeading>{`${getTitle(signatory)} ${reviewTitle}`}</SectionHeading>
            <div>
              {this.state.isFormEditable ? (
                <OldAddSignatoryPage
                  brandId={brandId}
                  bankId={bankId}
                  currentSignatoryIndex={signatoriesIndex}
                  saveOldAddSignatoryForm={values => {
                    this.onEditButtonClick();
                    updateOldSignatories(values, signatoriesIndex);
                  }}
                  getBusinessData={signatory}
                  fromAccordion={true}
                />
              ) : (
                <GenericDescriptionList
                  items={this.getItems(
                    personDetailsFirstName,
                    personDetailsMiddleName,
                    personDetailsLastName,
                    personDetailsDOB,
                    nationalityTitle,
                    countryOfResidence,
                    signatory
                  )}
                />
              )}
              {!signatory.isPrimary && (
                <div>
                  <NavigationButton.Tertiary
                    labelText={this.state.isFormEditable ? 'Cancel Editing' : 'Edit'}
                    onClick={e => {
                      this.onEditButtonClick();
                      e.preventDefault();
                    }}
                  />
                  {!this.state.isFormEditable && (
                    <NavigationButton.Tertiary
                      labelText="Remove"
                      onClick={e => {
                        e.preventDefault();
                        removeOldSignatories(signatoriesIndex);
                      }}
                    />
                  )}
                </div>
              )}
            </div>
          </>
        )}
      </Content>
    );
  }
}

OldSignatoriesAccordian.propTypes = {
  bankId: PropTypes.bankId.isRequired,
  saveOldSignatoriesForm: PropTypes.func.isRequired
};

export default OldSignatoriesAccordian;
